import React from 'react';
import { arrayOf, bool, object, shape, string } from 'prop-types';
import LandingLink from './LandingLink';
import SectionHead from './SectionHead';

/**
 * The card grid used both for "Kategorien in X" and "Weitere Regionen".
 * One component because the markup and styling are identical; only the items
 * and whether they carry an icon differ.
 */
const CardGrid = props => {
  const { id, heading, text, items, alt, footerLink, ariaLabel } = props;
  if (!items.length) {
    return null;
  }
  return (
    <section
      className={alt ? 'section-alt' : undefined}
      aria-labelledby={heading ? id : undefined}
      aria-label={heading ? undefined : ariaLabel}
    >
      <div className="container">
        {heading ? <SectionHead id={id} heading={heading} text={text} /> : null}
        <div className="categories">
          {items.map(item => (
            <LandingLink className="cat" link={item.link} key={item.key}>
              {item.image ? (
                <span className="cat-icon" aria-hidden="true">
                  <img src={item.image} alt="" loading="lazy" decoding="async" />
                </span>
              ) : null}
              <span className="cat-name">{item.label}</span>
            </LandingLink>
          ))}
        </div>
        {footerLink ? (
          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <LandingLink className="btn btn-ghost" link={footerLink.link}>
              {footerLink.label}
            </LandingLink>
          </div>
        ) : null}
      </div>
    </section>
  );
};

CardGrid.propTypes = {
  id: string.isRequired,
  heading: string,
  ariaLabel: string,
  text: string,
  items: arrayOf(shape({ key: string, link: object, label: string, image: string })),
  alt: bool,
  footerLink: shape({ link: object, label: string }),
};
CardGrid.defaultProps = { items: [] };

export default CardGrid;
